import { Injectable } from '@tanbo/vue-di-plugin'
import { TableList, TableMemoryPagination } from '@/services/table-memory-pagination'
import { Http } from '@/services/http'
import { ParamsClean } from '@/common/decorators/params-clean'
import { AuthStatusList } from '@/views/dashboard/_type/client-item'
import { getAreaByTerminalType } from '@/services/service-permission.service'

export interface QueryParams {
  // 计算机名 / 登记用户名
  key_word?: string
  /** 分组id */
  group_id: number
  /** 页码 */
  page: number
  /** 每页数量 */
  limit: number
  /** 排序 */
  asc?: boolean
  /** 排序字段 */
  sort?: string
  /** 是否使用内存数据 */
  useMemory: boolean,
  /** 系统类型 1-windows 2-linux 3-win server 4-mac */
  system_types: number[]
  permission_names?: string[]
  device_list?:string[]
}
export interface TerminalItem {
  /** 终端设备id */
  device_id: string
  /** 计算机名 */
  computer_name: string
  /** 登记用户名 */
  user_mark: string
  /** 内网ip */
  system_ip: string
  /** 外网ip */
  client_ip: string
  /** 操作系统名 */
  system_name: string
  /** 上次扫描时间戳,单位秒 */
  last_scan_time: number
  /** 登录状态,1-在线，2-离线 */
  login_status: number
  system_type?: number
  /** 授权状态集合 */
  auth_status?: AuthStatusList[]
  /** 前端字段 */
  area_type?: number
  // 扫描状态 0-未扫描，1-扫描中，2-扫描完成，3-扫描失败，4-扫描超时
  scan_status: 0|1|2|3|4
}
export interface ScanParams {
  /** 选择类型,0-指定终端，1-指定分组 */
  select_type: number
  /** 终端设备id列表 */
  device_list: string[]
  /** 分组id */
  group_id: number
}
export interface ScanResult {
  /** 扫描完成数 */
  success_count: number
  /** 扫描总数 */
  scan_total: number
  /** 是否已完成 */
  isFinish: boolean
}
@Injectable()
export class TerminalDrawerService extends TableMemoryPagination<QueryParams, TerminalItem> {
  constructor (private http: Http) {
    super()
  }

  isEqual (left: TerminalItem, right: TerminalItem): boolean {
    return left.device_id === right.device_id
  }

  @ParamsClean()
  getListByServer (params: Partial<QueryParams>): Promise<TableList<TerminalItem>> {
    return this.http.post<{
      list: TerminalItem[]
      enable_total: number
      total: number
    }>('/leak/scan-terminals/get', params).then(res => {
      res.list.forEach(v => v.area_type = getAreaByTerminalType(v.system_type))
      return res
    })
  }

  getLeakScan (data: ScanParams) {
    return this.http.post<{ task_id: string }>('/leak/scan', data)
  }

  getScanResult (data: { task_id: string }) {
    return this.http.post<ScanResult>('/leak/scan-result/get', data)
  }
}
